import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { Text, TextPreset, ShadeColor } from '@pegasus/ui-components/components/text';
import { injectConfig, configShape } from '@client/hoc/config';
import Translate from '@client/components/shared/translation/Translate';
import { timeToArray } from '../../../../helpers';
import {
    getTodayFormat,
    getTimerFormat,
    getShortTimerFormat,
    getDateTimeFormat,
    getShortDayHourFormat
} from '../../../../helpers/timeLeft';

import styles from './styles.scss';

@CSSModules(styles, { allowMultiple: true })
export class TimeLeftBold extends React.Component {
    state = {
        timeLeft: 0,
    };

    static propTypes = {
        dateTill: PropTypes.number.isRequired,
        dateFrom: PropTypes.number.isRequired,
        isUpcoming: PropTypes.bool,
        isOpen: PropTypes.bool,
        isCampaignPage: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        expiredCallback: PropTypes.func,
        config: configShape,
    }

    render() {
        const {
            isUpcoming,
            isCampaignPage,
            intl
        } = this.props;

        const { id, values } = isUpcoming ? this.getTimeLeftUpcoming(intl) : this.getTimeLeft();
        const prefix = this.getTimerPrefix();

        return (
            <p styleName="wrapper">
                <span styleName={classNames('content', { upcoming: isUpcoming })}>
                    <Text color={ShadeColor.dark60} preset={TextPreset.XXS} styleName="text">
                        <Translate message={prefix} />
                    </Text>
                    <span styleName={classNames('countdown', {
                        upcoming: isUpcoming,
                        'campaign-page': isCampaignPage
                    })}
                    >
                        <FormattedHTMLMessage id={id} values={values} />
                    </span>
                </span>
            </p>
        );
    }

    getTimeLeft() {
        const { timeLeft } = this.state;
        const [days] = timeToArray(timeLeft);

        return days > 0 ? getShortDayHourFormat(timeLeft) : getShortTimerFormat(timeLeft);
    }

    getTimerPrefix() {
        const { timeLeft } = this.state;
        const { isUpcoming } = this.props;

        const [days, hours] = timeToArray(timeLeft);

        if (!isUpcoming) {
            return 'timeLeft.endsIn';
        }

        return days === 0 && hours < 12 ? 'timeLeft.startsIn' : 'timeLeft.startsOn';
    }

    getTimeLeftUpcoming(intl) {
        const { timeLeft } = this.state;
        const { config: { dateTimeFormat = {} } } = this.props;

        const [days, hours] = timeToArray(timeLeft);
        const today = new Date();
        const date = new Date(today.getTime() + 1000 + timeLeft);
        const isSameDay = today.getYear() === date.getYear() &&
            today.getDate() === date.getDate() &&
            today.getMonth() === date.getMonth();

        if (isSameDay) {
            return getTodayFormat(timeLeft);
        }

        if (days === 0 && hours < 12) {
            return getTimerFormat(timeLeft);
        }

        return getDateTimeFormat(timeLeft, dateTimeFormat, intl);
    }

    componentWillMount() {
        const timeLeft = this.props.dateTill - Date.now();
        const tickThreshold = this.props.isUpcoming ? 12 : 24;
        const [
            days,
            hours
        ] = timeToArray(timeLeft);

        const secondTick = 1000;
        const minuteTick = 60 * 1000;

        // set different intervals for short: 1 second and for long: 1 minute
        this.timer = setInterval(
            this.tick.bind(this),
            (hours < tickThreshold && days < 1) ? secondTick : minuteTick
        );

        this.setState({
            timeLeft
        });
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    tick() {
        // Prevent negative numbers in countdowns
        let timeLeft = this.props.dateTill - Date.now();
        if (timeLeft < 0) {
            timeLeft = 0;
            clearInterval(this.timer);
            if (this.props.expiredCallback) {
                this.props.expiredCallback();
            }
        }

        this.setState({
            timeLeft
        });
    }
}

export default compose(
    injectConfig,
    injectIntl
)(TimeLeftBold);
